module.exports = __webpack_public_path__ + "static/media/logical-and.370a6ec8.png";